import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accounting-land-screen',
  templateUrl: './accounting-land-screen.component.html',
  styleUrls: ['./accounting-land-screen.component.css']
})
export class AccountingLandingScreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
